var DeviceType;!function(e){e.Mobile="mobile",e.Tablet="tablet",e.Desktop="desktop"}(DeviceType=DeviceType||{});var DeviceType$1=DeviceType;export default DeviceType;
